export default __webpack_public_path__ + "static/absoluteImage-e39b37d725fc43b584381ff9006b138c.svg";